//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyDocuments from './CardPropertyDocuments.vue'
import CardPropertyList from './CardPropertyList.vue'
import CardPropertyListValue from './CardPropertyListValue.vue'
import CardPropertyBoolean from './CardPropertyBoolean.vue'
import CardPropertyNumber from './CardPropertyNumber.vue'
import CardPropertyObject from './CardPropertyObject.vue'
import CardPropertyDate from './CardPropertyDate.vue'
import CardPropertyDuration from './CardPropertyDuration.vue'
import CardPropertyTable from './CardPropertyTable.vue'
import CardPropertyString from './CardPropertyString.vue'
import CardPropertyGeoPoint from './CardPropertyGeoPoint.vue'
import CardPropertyValueChange from './CardPropertyValueChange.vue'
import CardPropertyAddress from './CardPropertyAddress.vue'
import CardPropertyBrigade from './CardPropertyBrigade.vue'
import CardPropertyDefault from './CardPropertyDefault.vue'
import CardSeparator from './CardSeparator.vue'

export default {
  name: 'CardSectionProperties',
  components: {
    CardPropertyDocuments,
    CardPropertyList,
    CardPropertyListValue,
    CardPropertyBoolean,
    CardPropertyNumber,
    CardPropertyObject,
    CardPropertyDate,
    CardPropertyDuration,
    CardPropertyTable,
    CardPropertyString,
    CardPropertyGeoPoint,
    CardPropertyValueChange,
    CardPropertyAddress,
    CardPropertyBrigade,
    CardSeparator,
    CardPropertyDefault
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  created () {
    // this.config.props.forEach(prop => {
    //   if (!prop.component) {
    //     switch (prop.type) {
    //       case 'separator':
    //         break
    //       case 'listvalue':
    //         prop.component = CardPropertyListValue
    //         break
    //       case 'boolean':
    //         prop.component = CardPropertyBoolean
    //         break
    //       case 'integer':
    //       case 'double':
    //         prop.component = CardPropertyNumber
    //         break
    //       case 'object':
    //       case 'objects':
    //       case 'sysobject':
    //       case 'sysobjects':
    //         prop.component = CardPropertyObject
    //         break
    //       case 'date':
    //       case 'datetime':
    //         prop.component = CardPropertyDate
    //         break
    //       case 'table':
    //         prop.component = CardPropertyTable
    //         break
    //       case 'string':
    //         prop.component = CardPropertyString
    //         break
    //       default:
    //         prop.component = CardPropertyDefault
    //         break
    //     }
    //   }
    // })
  }
}
